@import 'src/global/theme-variables';

.rv-container {
  display: flex;
  padding: 16px;
  position: relative;
  border: 1px solid #eee;
  border-radius: 7px;
  flex-direction: column;
  justify-content: space-between;
  width: auto;

  p {
    margin-block: 0;
  }

  * {
    font-family: Inter, Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue',
      Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  }
}

.rv-header-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.rv-valuation-group {
  width: calc(50% - 24px);
  min-width: 480px;
  display: flex;
  justify-content: flex-start;
  margin-right: 24px;
  @media screen and (max-width: 500px) {
    flex-direction: column;
    min-width: 780px;
  }
}

.rv-valuation-section {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 8px;
  overflow: visible;
  flex-basis: 50%;
  min-width: 240px;

  .rv-valuation-title {
    @media screen and (min-width: 500px) {
      padding-left: 24px;
    }
  }

  .rv-valuation-value-row {
    @media screen and (min-width: 500px) {
      padding-left: 24px;
      border-left: thin solid #e0e0e0;
    }
  }

  &:first-child {
    .rv-valuation-title {
      @media screen and (min-width: 500px) {
        margin-left: -25px;
      }
    }

    .rv-valuation-value-row {
      @media screen and (min-width: 500px) {
        margin-left: -25px;
      }
    }
  }
}

.rv-valuation-container {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-top: 8px;
  overflow: hidden;
  @media screen and (min-width: 500px) {
    row-gap: 15px;
  }
}

.rv-title {
  display: flex;
  color: $secondary;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  padding: 0;
  text-align: left;
  flex-grow: 1;
  line-height: 1.235;
  align-items: baseline;
}

.rv-valuation-title {
  font-weight: 600;
  font-size: 14px;
  color: #000;
  padding-bottom: 6px;
}

.rv-valuation-value-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
}

.rv-valuation-value {
  color: #212121;
  -webkit-font-smoothing: antialiased;
  font-size: 24px;
  font-weight: 600;
}

.rv-valuation-percentage {
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
  font-size: 14px;
}

.rv-income-statements-chart-percentage {
  visibility: inherit;
  -webkit-font-smoothing: antialiased;
  margin: 0;
  line-height: 1.5;
  display: flex;
  flex-direction: row;
  font-size: 14px;
  font-weight: 500;
  padding-left: 8px;

  .rv-positive {
    color: $positive;
  }

  .rv-negative {
    color: $negative;
  }
}

.rv-score-last-updated {
  align-self: center;
  text-align: center;
  font-size: 12px;
  color: #757575;
  font-weight: 500;
  line-height: 28px;
}
